import flatten from 'lodash/flatten'

const orderedOnboardingPhaseStepsMap = {
  parse_resume: ['resume'],
  ideal_job: ['area-roles', 'skills', 'employment-type', 'city'],
  about_you: ['job-search', 'citizenship-status', 'salary-expectations', 'contact-number'],
  your_experience: ['work-experience', 'education'],
  wrap_up: ['wrapping-up'],
}
export const orderedOnboardingSteps = flatten(Object.values(orderedOnboardingPhaseStepsMap))
const orderedOnboardingPhases = flatten(Object.keys(orderedOnboardingPhaseStepsMap))

const separateUrlAndStep = url => {
  const urlParts = url.split('/')
  const urlWithoutStep = urlParts.slice(0, -1).join('/')
  const step = urlParts[urlParts.length - 1]

  return [urlWithoutStep, step]
}

export const previousOnboardingUrl = currentUrl => {
  const [url, currentStep] = separateUrlAndStep(currentUrl)

  const currentIndex = orderedOnboardingSteps.findIndex(step => currentStep === step)

  if (currentIndex === 0) return null
  return `${url}/${orderedOnboardingSteps[currentIndex - 1]}`
}

export const nextOnboardingUrl = currentUrl => {
  const [url, currentStep] = separateUrlAndStep(currentUrl)

  const currentIndex = orderedOnboardingSteps.findIndex(step => currentStep === step)

  if (currentIndex + 1 === orderedOnboardingSteps.length) return null
  return `${url}/${orderedOnboardingSteps[currentIndex + 1]}`
}

export const canAccessStep = (currentUrl, onboardingPhase) => {
  const [_, currentStep] = separateUrlAndStep(currentUrl)
  const phaseIndex = orderedOnboardingPhases.findIndex(phase => phase === onboardingPhase)

  const availablePhases = orderedOnboardingPhases.slice(0, phaseIndex + 1)
  const availableSteps = availablePhases.reduce((steps, phase) => [...steps, ...orderedOnboardingPhaseStepsMap[phase]], [])

  return availableSteps.includes(currentStep)
}

export const firstOnboardingStepUrl = candidateId => {
  const firstPhase = orderedOnboardingPhases[0]
  return `/candidate/${candidateId}/${orderedOnboardingPhaseStepsMap[firstPhase][0]}`
}

export const firstStepUrlInOnboardingPhase = (onboardingPhase, candidateId) => {
  const steps = orderedOnboardingPhaseStepsMap[onboardingPhase]
  if (steps) return `/candidate/${candidateId}/${steps[0]}`

  return firstOnboardingStepUrl(candidateId)
}
